import {autoserialize, autoserializeAs, inheritSerialization} from 'cerialize';
import {MomentTransformer} from '../helpers/moment-transformer';
import * as moment from 'moment';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class RsvpNotification extends ModelBase {
  public static readonly type = 'RsvpNotification';
  public readonly type = RsvpNotification.type;

  @autoserialize
  public id: number;

  @autoserializeAs(MomentTransformer, 'time_sent')
  public timeSent: moment.Moment;

}
